// Provider results enter the existing CMA through one flat, replaceable
// snapshot. An absent field/comparable stays absent rather than borrowing it
// from a previous property's report.
export function propertyReportSnapshot(data,{ userId='',leadId='',propertyId='',address='' }={}) {
    const provider=(typeof data?.source==='string' ? data.source : data?.source?.provider) || data?.provider || 'lightstone';
    const snapshot={ ...(data?.fields || {}),comparables:(data?.comparables || []).map((row,index) => ({ ...row,include:index<6 })),
        comparablesAveragePrice:data?.comparablesAveragePrice || '',
        source:typeof data?.source==='object' ? data.source : { provider },provenance:data?.provenance || null,sections:data?.sections || null,
        subject:{ userId:String(userId),leadId:String(leadId),propertyId:String(propertyId),address },
    };
    if (provider === 'cma-info') {
        if (data?.sourceSnapshot) snapshot.sourceSnapshot=data.sourceSnapshot;
    } else if (data?.savedFile?.id) snapshot.savedFile=data.savedFile;
    return snapshot;
}

// Background PDF jobs are shared by the whole app. Only jobs started for this
// account and exact CRM/property context may populate or advertise this report.
export function propertyReportJobMatches(job,{ userId='',leadId='',propertyId='',address='' }={}) {
    const identitiesMatch=Boolean(job && userId && leadId && (!job.owner || job.owner==='cma')
        && String(job.userId || '')===String(userId)
        && String(job.leadId || '')===String(leadId)
        && String(job.propertyId || '')===String(propertyId || ''));
    if (!identitiesMatch || propertyId) return identitiesMatch;
    const normalize=value => String(value || '').normalize('NFKC').trim().toLowerCase().replace(/\s+/g,' ').replace(/\s*,\s*/g,',');
    const chosen=normalize(address);
    return Boolean(chosen && normalize(job.reportAddress || job.query)===chosen);
}

const number=value => {
    const parsed=Number(String(value ?? '').replace(/[^\d.-]/g,''));
    return Number.isFinite(parsed) && parsed>0 ? parsed : undefined;
};

// Populate the report's existing data/derived-metrics layer without asking a
// second enrichment service to reinterpret the same provider response.
export function propertyReportMetadata(snapshot) {
    if (snapshot?.source?.provider !== 'cma-info') return null;
    const s=snapshot;
    const comparable_properties=(s.comparables || []).map(row => ({ address:row.address,price:number(row.salesPrice),
        sale_date:row.salesDate || row.regDate,erf_sqm:number(row.erfSize),build_sqm:number(row.areaUnderRoof),square_meters:number(row.areaUnderRoof) })).filter(row => row.price);
    return {
        metadata:{ provider:'cma-info',country:'ZA',currency:'ZAR',source:s.source,provenance:s.provenance,reportContext:s.reportContext },
        property:{ address:s.streetAddress,erf_number:s.erfNumber,scheme_name:s.scheme,municipality:s.municipality,sg_code:s.sgCode,
            property_type:s.dwellingType,characteristics:{ square_meters:number(s.floorSize),lot_size_sqm:number(s.erfSize) } },
        valuation:{ current_estimate:{ value:number(s.estimatedValue),currency:'ZAR',confidence_range:{ low:number(s.valuationLow),high:number(s.valuationHigh) } },
            tax_assessment:{ value:number(s.municipalValue),year:s.municipalValuationYear },registered_bond:{ amount:number(s.bondAmount),holder:s.bondHolder,currency:'ZAR' } },
        transaction_history:s.purchasePrice ? [{ price:number(s.purchasePrice),date:s.purchaseDate,currency:'ZAR' }] : [],
        market_data:{ comparable_properties },
    };
}
